import { schema } from 'normalizr';
import credentialSchema from './credential';
import dataSetSchema, { sharedDataSetSchema } from './dataSet';
import flowNodeSchema from './flowNode';
import orgsSchema from './org';
import projectSchema from './project';
import sinkSchema from './sink';
import sourceSchema from './source';
import usersSchema from './user';
import transformSchema from './transform';
import { dataMapSchema } from 'js/schemas/index';
import credentialsGroupSchema from './credentialsGroup';

const pipelineSchema = new schema.Values(
  {
    code_containers: [transformSchema],
    flows: [flowNodeSchema],
    linked_flows: [flowNodeSchema],
    triggering_flows: [flowNodeSchema],
    data_sets: [dataSetSchema],
    shared_data_sets: [sharedDataSetSchema],
    data_sources: [sourceSchema],
    dependent_data_sources: [sourceSchema],
    data_sinks: [sinkSchema],
    data_maps: [dataMapSchema],
    data_credentials: [credentialSchema],
    data_credentials_groups: [credentialsGroupSchema],
    users: [usersSchema],
    orgs: [orgsSchema],
    projects: [projectSchema],
  },
  (value, parent, key) => {
    return key;
  },
);

export default pipelineSchema;
